/* SEERAT v5.4.0 — Facticied */
(function () {
  'use strict';

  function measure() {
    var header = document.querySelector('.section-header');
    if (!header) return;
    document.documentElement.style.setProperty('--seerat-header-h', header.offsetHeight + 'px');
  }

  function hoverMenus() {
    var nav = document.querySelector('.seerat-nav[data-open-on="hover"]');
    if (!nav || nav.dataset.hoverReady === 'true') return;
    nav.dataset.hoverReady = 'true';

    var canHover = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    if (!canHover) return;

    // Top level items only. Dawn's dropdown lists also use .list-menu, so never match nested li.
    var topList = nav.querySelector(':scope > ul');
    if (!topList) return;
    var items = Array.prototype.filter.call(topList.children, function (n) { return n.tagName === 'LI'; });

    var current = null;
    var closeTimer = null;
    var switchTimer = null;

    function panelOf(li) {
      var d = li.querySelector('details');
      var s = d ? d.querySelector('summary') : null;
      return s ? s.nextElementSibling : null;
    }

    function openItem(li) {
      if (current && current !== li) closeItem(current);
      var d = li.querySelector('details');
      if (!d) { current = null; return; }
      if (!d.hasAttribute('open')) {
        d.setAttribute('open', '');
        var s = d.querySelector('summary');
        if (s) s.setAttribute('aria-expanded', 'true');
      }
      current = li;
    }

    function closeItem(li) {
      var menu = li.querySelector('header-menu');
      if (menu && typeof menu.close === 'function') menu.close();
      if (current === li) current = null;
    }

    // Inside the item, its panel, or the corridor between them
    function inZone(li, x, y) {
      var r = li.getBoundingClientRect();
      if (x >= r.left && x <= r.right && y >= r.top && y <= r.bottom) return true;
      var p = panelOf(li);
      if (!p) return false;
      var q = p.getBoundingClientRect();
      if (q.height === 0) return false;
      var left = Math.min(r.left, q.left);
      var right = Math.max(r.right, q.right);
      return y > r.bottom - 2 && y <= q.bottom && x >= left && x <= right;
    }

    var pending = false;
    document.addEventListener('mousemove', function (e) {
      if (!current || pending) return;
      pending = true;
      var x = e.clientX;
      var y = e.clientY;
      window.requestAnimationFrame(function () {
        pending = false;
        if (!current) return;
        if (inZone(current, x, y)) {
          clearTimeout(closeTimer);
          closeTimer = null;
        } else if (!closeTimer) {
          closeTimer = setTimeout(function () {
            closeTimer = null;
            if (current) closeItem(current);
          }, 250);
        }
      });
    }, { passive: true });

    items.forEach(function (li) {
      var summary = li.querySelector('details > summary');

      li.addEventListener('mouseenter', function () {
        if (li === current) {
          clearTimeout(closeTimer);
          closeTimer = null;
          return;
        }
        clearTimeout(switchTimer);
        if (!current) {
          openItem(li);
        } else {
          // Hover intent: only switch if the pointer rests here, not when passing over
          switchTimer = setTimeout(function () {
            if (li.matches(':hover')) {
              clearTimeout(closeTimer);
              closeTimer = null;
              openItem(li);
            }
          }, 180);
        }
      });

      li.addEventListener('mouseleave', function () {
        clearTimeout(switchTimer);
      });

      // Mouse click on the top link opens its page; keyboard (detail 0) still toggles the menu
      if (summary) {
        summary.addEventListener('click', function (e) {
          if (e.detail === 0) return;
          var url = summary.getAttribute('data-url');
          e.preventDefault();
          if (url && url !== '#') window.location.href = url;
        });
      }
    });
  }

  function init() {
    hoverMenus();
    var header = document.querySelector('.section-header');
    if (!header) return;
    measure();
    if ('ResizeObserver' in window) {
      new ResizeObserver(measure).observe(header);
    } else {
      window.addEventListener('resize', measure);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function () {
    measure();
    hoverMenus();
  });
})();
